export const ENDPOINT = '/analytics/uuid.json';
